import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { Layout } from "@/components/Layout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import TrustedPartners from "@/pages/TrustedPartners";
import PartnerInquiry from "@/pages/PartnerInquiry";
import Contact from "@/pages/Contact";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/partners" element={<TrustedPartners />} />
            <Route path="/partners/connect" element={<PartnerInquiry />} />
            <Route path="/contact" element={<Contact />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster
        position="top-right"
        theme="dark"
        toastOptions={{
          style: { background: "#18181B", border: "1px solid #3F3F46", color: "#fff", borderRadius: "2px" },
        }}
      />
    </div>
  );
}

export default App;
